import React from 'react';
import { connect } from 'react-redux';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import { getParams } from 'actions/stats';
import { chainGetPNG, dumpAllToPDF } from "./functions"

class HeatmapExport extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false
        }
    }

    downloadPDF() {
        this.setState({ loading: true }, () => {
            var images = [];
            chainGetPNG([
                this.props.heatmap
            ], images,
                () => {
                    this.setState({ loading: false });
                    dumpAllToPDF(images, this.getPDFName());
                });
        });
    }

    getPDFName() {
        let settings = getParams({
            querySettings: this.props.querySettings,
            currentNode: this.props.node
        });
        let locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
        return `WIDGET_${locationName}_${settings.startdate}_${settings.enddate}_${settings.starthour}:00_${settings.endhour}:59.pdf`;
    }


    render() {
        return (
            <Dropdown className={this.props.className} header={
                <div className={"heatmap-export " + (this.state.loading ? "loading" : "")}>
                    {
                        this.state.loading ?
                            <img src="src/assets/icons/loading.gif" />
                            :
                            <span data-tooltip="Export data" className="font-icon icon-export" />
                    }

                </div>
            } toggleable={!this.state.loading} noArrow>
                <DropdownItem>
                    <div onClick={() => this.downloadPDF()}>
                        PDF : Picture of heatmap
                        </div>
                </DropdownItem>
            </Dropdown>
        );
    }
}

function mapStateToProps(state) {
    return {
        tree: state.overviewReducer.customerOverview,
        nodeMap: state.overviewReducer.nodeMap,
        querySettings: state.querySettingsReducer,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HeatmapExport);


// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dataexportdropdown/heatmapexport.jsx